
import moment from 'moment'

export default {
  lockScreen ({ commit }) {
    commit('user/lock')
  },
  unlockScreen ({ commit, dispatch }, user) {
    commit('user/unlock', user)
    dispatch('sync/orders')
    dispatch('cashControl/getTurn').catch(e => console.warn(e))
  },
  async log ({ state, getters }, log) {
    try {
      console.log(`log: ${log.action} [${log.model} ${log.model_id}]`)
      await state.db.add('logs', {
        ...log,
        created_at: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        tenantUserName: getters['user/fullName'] || 'Unknown',
        tenantUser_id: state.user.id,
        uuid: state.UUID,
      })
    } catch (err) {
      console.warn(`Could not log: ${log.action}`)
      AndroidDevice.warn(state.db === undefined
        ? 'The IndexedDB has not been created yet'
        : (err.name || 'IndexedDB undefined error')
      )
    }
  },
  $log ({ dispatch }, action) {
    dispatch('log', { action, model: 'No model', model_id: null })
  },
  // Handle AJAX error responses showing a global alert message
  xError: ({ dispatch, rootGetters }, e) => {
    const r = e.response
    if (r && 'status' in r) {
      switch (r.status) {
        case 401:
        case 419:
          // 401 Unauthorized
          // 419 Page Expired due a CSRF token mismatch
          // These errors usually occurs when a logged user loses the session,
          // so we reload the page and the backend will redirect for us.
          dispatch('$log', `X-Error: ${r.status} (auto-reload)`)
          window.location.reload()
          break
        case 422:
          // 422 Unprocessable Entity (Laravel's validate error responses)
          const errors = Object.values(e.response.data.errors)
          dispatch('$log', `X-Error: 422 ${errors.join(' - ')}`)
          dispatch('alert/showWarning', errors.join('<br>'))
          break
        default:
          // 403 Forbidden
          // 404 Not Found
          // 405 Method Not Allowed
          // 418 I'm a teapot (API errors)
          // 529 Too Many Requests
          // 500 Internal Server Error
          // 501 Not Implemented
          // 503 Service Unavailable
          // ...
          const message = r.data.message || r.statusText || 'Unknown error'
          dispatch('$log', `X-Error: ${r.status} ${message}`)
          dispatch('alert/showError', message)
      }
    } else if (e.request) {
      // No response due a network error (do not log this error because it
      // happens very often)
      dispatch('alert/showWarning', rootGetters['translate']('connectionFailed') ?? 'Connection error')
    } else {
      dispatch('$log', 'X-Error: uncatched error')
      console.error(e)
    }
  },
}
